import { Input, Form, Button, notification } from 'antd';
import { Editor } from '@tinymce/tinymce-react';
import Axios from 'axios';
import { SERVER_URL } from '../../../../config/index';
import { useAuth } from '../../../../context/useAuth';
import { useNavigate, Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import UpdateBlogForm from '../UpdateBlog/UpdateBlogForm';

const UpdateBlog = (props) => {
  const { user } = useAuth();
  const { token } = user;

  const [data, setData] = useState();
  const [isDataFetched, setIsDataFetched] = useState(false);

  const lastIndex = window.location.pathname.lastIndexOf('/');
  const blogId = window.location.pathname.slice(lastIndex + 1);

  useEffect(() => {
    fetchData();
  }, [blogId]);

  const fetchData = async () => {
    try {
      const res = await Axios.get(`${SERVER_URL}/blog/${blogId}`, {
        withCredentials: false,
        headers: { Authorization: `Bearer ${token}` },
      });

      setData(res.data.item);
      setIsDataFetched(true);
    } catch (error) {
      console.error('Error fetching the data:', error);
    }
  };

  return <div className="title-container">{data && isDataFetched && <UpdateBlogForm isNew={false} data={data} />}</div>;
};

export default UpdateBlog;
